<div class="chat-dialog">
  <div class="chat-dialog-header">
    <div class="chat-title">
      <app-chat-channel-image [channel]="groupChannel"></app-chat-channel-image>
  
      <div class="chat-channel-title" ellipsis [ellipsis-content]="groupChannel?.name"></div>
    </div>

    <div class="chat-header-actions">
      <app-icon-button [icon]="collapsed ? 'arrow-line-up' : 'minus'" class="collapse-button" [ariaLabel]="collapsed ? 'Extend' : 'Collapse'" (click)="changeDialogState()"></app-icon-button>
      <app-icon-button icon="x" [ariaLabel]="'Close'" (clicked)="closeDialog()"></app-icon-button>
    </div>
  </div>

  <div class="chat-channel">
    <app-chat-channel [groupChannel]="groupChannel" [hideBorder]="false" [disabled]="collapsed"></app-chat-channel>
  </div>
</div>
